import { request } from '@umijs/max';

export async function fetchProductListItems(listId: any) {
  return request(`/data/fetch_product_list_items/${listId}`);
}

export async function fetchDefaultPeopleListItems(
  params: { page?: number; pageSize?: number } = {},
) {
  return request('/people-v2/default-list-items', {
    method: 'GET',
    params,
  });
}

export async function fetchAllDefaultPeopleListItemsForExport() {
  return request('/people-v2/default-list-items-export', {
    method: 'GET',
  });
}

export async function fetchPhoneForListPerson(personData: any) {
  return request('/people-v2/fetch_phone', {
    method: 'POST',
    data: personData,
  });
}

export async function renameProductList(listId: number, name: string) {
  return request(`/data/product-list/${listId}`, {
    method: 'PATCH',
    data: { name },
  });
}

export async function deleteProductList(listId: number) {
  return request(`/data/product-list/${listId}`, {
    method: 'DELETE',
  });
}

export async function deleteProductListItems(listId: number, itemIds: number[]) {
  return request(`/data/product-list/${listId}/items`, {
    method: 'DELETE',
    data: { itemIds },
  });
}

export async function renamePeopleList(listId: number, name: string) {
  return request(`/people-v2/list/${listId}`, {
    method: 'PATCH',
    data: { name },
  });
}

export async function deletePeopleList(listId: number) {
  return request(`/people-v2/list/${listId}`, {
    method: 'DELETE',
  });
}

export async function deletePeopleListItems(listId: number, itemIds: number[]) {
  return request(`/people-v2/list/${listId}/items`, {
    method: 'DELETE',
    data: { itemIds },
  });
}
